export type ServiceLevelNoticePageKey = 'internal' | 'corporation' | 'corporationLeadPlusOne'

export const SERVICE_LEVEL_NOTICE_HIDDEN_PAGES_SELECTIONS = [
  { label: '社内向け', value: 'internal' as const },
  { label: '法人向け', value: 'corporation' as const },
  { label: 'LT+1日版(法人向け)', value: 'corporationLeadPlusOne' as const },
]

const VALID_PAGE_KEYS = new Set<string>(
  SERVICE_LEVEL_NOTICE_HIDDEN_PAGES_SELECTIONS.map((s) => s.value),
)

const HIDDEN_PAGE_LABEL_BY_VALUE = new Map<string, string>(
  SERVICE_LEVEL_NOTICE_HIDDEN_PAGES_SELECTIONS.map((s) => [s.value, s.label]),
)

/**
 * 管理画面一覧などで hidden_pages の value を日本語ラベルに変換する
 */
export const formatHiddenPagesForDisplay = (hiddenPages: unknown): string => {
  const pages = parseHiddenPages(hiddenPages)
  if (pages.length === 0) {
    return ''
  }
  return pages
    .map((value) => HIDDEN_PAGE_LABEL_BY_VALUE.get(value) ?? value)
    .join('、 ')
}

/**
 * MULTISELECT (CSV) / JSON 配列など複数形態の hidden_pages を string[] に正規化する
 */
export const parseHiddenPages = (hiddenPages: unknown): string[] => {
  if (hiddenPages == null || hiddenPages === '') {
    return []
  }
  if (Array.isArray(hiddenPages)) {
    return hiddenPages.filter((v): v is string => typeof v === 'string' && v.length > 0)
  }
  if (typeof hiddenPages === 'string') {
    const trimmed = hiddenPages.trim()
    if (!trimmed) return []
    if (trimmed.startsWith('[')) {
      try {
        const parsed = JSON.parse(trimmed)
        if (Array.isArray(parsed)) {
          return parsed.filter((v): v is string => typeof v === 'string' && v.length > 0)
        }
      } catch {
        // fall through to CSV split
      }
    }
    return trimmed
      .split(',')
      .map((s) => s.trim())
      .filter((s) => s.length > 0)
  }
  return []
}

/**
 * 指定ページでお知らせを表示するか（hidden_pages に pageKey が含まれていなければ表示）
 */
export const isServiceLevelNoticeVisibleOnPage = (
  hiddenPages: unknown,
  pageKey: ServiceLevelNoticePageKey,
): boolean => {
  const pages = parseHiddenPages(hiddenPages)
  if (pages.length === 0) {
    return true
  }
  return !pages.includes(pageKey)
}

/**
 * お知らせ取得失敗時の切り分け用メッセージ（hidden_pages の読み取り権限付与漏れの気付き用）
 */
export const SERVICE_LEVEL_NOTICE_HIDDEN_PAGES_DIRECTUS_HINT =
  '[YHC] サービスレベルお知らせの取得に失敗した場合: Directus の公開(匿名)ロールに yhc_service_level_notices.hidden_pages の読み取り権限を付与したか確認してください。'

export const isValidServiceLevelNoticePageKey = (
  value: string,
): value is ServiceLevelNoticePageKey => VALID_PAGE_KEYS.has(value)
